import React from 'react';
import style from "./style.module.css";
import footerlogo from "../../../assets/footerlogo.png";
import Minar from "../../../assets/minar.png";
import Map from "../../../assets/map.png";
import PhoneIcon from "../../../assets/PhoneIcon.png";
import pakistanIcon from "../../../assets/pakistanIcon.png";
import mosqueIcon from "../../../assets/mosqueIcon.png";
import wmap from "../../../assets/wmap.png";
import FedumanLogo from "../../../assets/FeduManLogo.png";
import GetitonIcon from '../../../assets/GetitonIcon.png';
import apple_playstore from "../../../assets/apple_playstore.jpg"

const Footer = () => {
    const { footer_container, containerOne, containerOnePiece, containerTwo } = style;
    const socialLinks = [{
        platform: "Facebook",
        link: "https://www.facebook.com/share/DuezdWqvykpw5pyM/?mibextid=LQQJ4d"
    }
        , {
        platform: "Youtube",
        link: "https://youtu.be/pouatBcg9FA?si=5avikfgrnWtSHWyd"
    },
    {
        platform: "Instagram",
        link: "https://www.instagram.com/ashrei.tech?igsh=MXJueWVmbXh5M2l1YQ=="
    }
        , {
        platform: "LinkedIn",
        link: "https://www.linkedin.com/company/ashrei-tech/"
    },]

    const linkOne = [
        { name: "Customer Support", url: "https://talentexpertz.com/#/Contact" },
        { name: "Contact Us", url: "https://talentexpertz.com/#/Contact" },
        // { name: "Terms & Conditions", url: "" },
        // { name: "Privacy Policy", url: "" }
    ];
    const linkTwo = [
        { name: "About Us", url: "https://talentexpertz.com/#/Aboutus" },
        { name: "Services", url: "https://talentexpertz.com/#/Services" },
        { name: "Career", url: "https://talentexpertz.com/#/Career" },
        { name: "Blog", url: "https://talentexpertz.com/#/blog" }
    ];

    return (
        <div
  className={`${footer_container} container-fluid px-3 px-md-3 px-lg-5 pt-0 pb-2`}
  style={{ backgroundColor: "#F8F8F4" }}
>
  <div className="row px-0 py-0 pt-4">
    {/* Footer Logo */}
    <div className="col-12 col-md-3 text-center text-md-left mb-4">
      <div className="mt-sm-3 p-0 pb-sm-4">
        <img src={footerlogo} alt="Talent Expert" className="img-fluid" />
      </div>
    </div>

    {/* Links and Branches */}
    <div className="col-12 col-md-9">
      <div className="row">
        {/* Help Links */}
        <div className="col-12 col-md-3 mb-4">
          <ul>
            <li className="mb-4 font20" style={{ color: "black" }}>
              Help
            </li>
            {linkOne.map((link, index) => (
              <li key={index} className="pb-3">
                <a href={link.url} style={{ color: "#160A54" }}>
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Resources Links */}
        <div className="col-12 col-md-3 mb-4">
          <ul>
            <li className="mb-4 font20" style={{ color: "black" }}>
              Resources
            </li>
            {linkTwo.map((link, index) => (
              <li key={index} className="pb-3">
                <a href={link.url} style={{ color: "#160A54" }}>
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Branches Section */}
        <div
          className="col-12 col-md-6 px-sm-5 px-md-0 mb-4"
          style={{
            backgroundImage: `url(${wmap})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "top center",
          }}
        >
          <div className="row">
            <div className="col-12 mb-4 font20" style={{ color: "black" }}>
              <p>Our Branches</p>
            </div>
          </div>
          <div className="row px-3" style={{ color: "#160A54" }}>
            {/* Branch 1 */}
            <div className="col-12 col-md-6 mb-4">
              <div className="row align-items-baseline">
                <div className="col-10 font20" style={{ color: "#160A54" }}>
                  <p>1st Branch</p>
                </div>
              </div>
              <div className="row my-3 align-items-baseline">
                <div className="col-12 font15">
                  <div style={{ color: "#160A54" }}>
                    House No A-201 SMCHS Block A Karachi
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 font15">
                  <div style={{ color: "#160A54" }}>00971545341272</div>
                </div>
              </div>
            </div>

            {/* Branch 2 */}
            <div className="col-12 col-md-6 mb-4">
              <div className="row align-items-baseline">
                <div className="col-10 font20">
                  <p>2nd Branch</p>
                </div>
              </div>
              <div className="row my-3 align-items-baseline">
                <div className="col-12 font15">
                  <div>
                    NASTP Building, Main Shahrah-e-Faisal Rd, Karachi
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 font15">
                  <div>03334168870</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter Signup */}
      <div className="row px-3 mt-5 mb-4" style={{ color: "#160A54" }}>
        <div className="col-12 col-md-3 text-center text-md-left p-0 pt-2 mb-3">
          <h5 style={{ color: "#160A54" }}>Newsletter Sign Up</h5>
        </div>
        <div className="col-12 col-md-7">
          <div
            className="input-group mx-auto"
            style={{
              maxWidth: "100%",
              padding: 4,
              border: "1px solid #160A54",
              borderRadius: "50px",
              overflow: "hidden",
            }}
          >
            <input
              type="email"
              className="form-control"
              placeholder="Enter your email here..."
              aria-label="Email"
              required
              style={{
                border: "none",
                color: "#160A54",
                fontSize: "15px",
              }}
            />
            <button
              className="btn"
              type="button"
              style={{
                fontSize: "11px",
                backgroundColor: "#160A54",
                margin: "5px",
                padding: "4px 20px",
                color: "white",
                borderRadius: "50px",
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Footer Bottom */}
  <hr className="px-5" />
  <div className="row justify-content-end">
    <div className="pr-4">
      <div className="row" style={{ gap: 10 }}>
        <div
          className=""
          style={{
            height: 28,
            width: 28,
            background: "#160A54",
            borderRadius: "50%",
          }}
        ></div>
        <div
          className=""
          style={{
            height: 28,
            width: 28,
            background: "#160A54",
            borderRadius: "50%",
          }}
        ></div>
        <div
          className=""
          style={{
            height: 28,
            width: 28,
            background: "#160A54",
            borderRadius: "50%",
          }}
        ></div>
        <div
          className=""
          style={{
            height: 28,
            width: 28,
            background: "#160A54",
            borderRadius: "50%",
          }}
        ></div>
      </div>
    </div>
  </div>
</div>

    );
}

export default Footer;
